import { render } from "./MobileOnboarding.vue?vue&type=template&id=66d102e1&scoped=true"
import script from "./MobileOnboarding.vue?vue&type=script&lang=js"
export * from "./MobileOnboarding.vue?vue&type=script&lang=js"

import "./MobileOnboarding.vue?vue&type=style&index=0&id=66d102e1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d102e1"]])

export default __exports__